import { __assign } from '../../../../_virtual/_tslib.js';
import React from 'react';
import { DragDropContext, Droppable } from 'react-beautiful-dnd';
import Collection from './Collection/Collection.js';
import { reorder } from './Collections.utils.js';

var Collections = function (_a) {
    var showActions = _a.showActions, collections = _a.collections, value = _a.value, expandedCollections = _a.expandedCollections, onChange = _a.onChange, onClick = _a.onClick, onClickChannel = _a.onClickChannel, onEdit = _a.onEdit, onAddChannel = _a.onAddChannel;
    var expandedCollectionsSet = new Set(expandedCollections);
    var handleDragEnd = function (result) {
        if (!result.destination || result.destination.index === -1)
            return;
        var updatedCollections = reorder(collections, result.source.index, result.destination.index);
        if (onChange)
            onChange(updatedCollections);
    };
    return (React.createElement(DragDropContext, { onDragEnd: handleDragEnd },
        React.createElement(Droppable, { droppableId: "droppable" }, function (provided) { return (React.createElement("div", __assign({}, provided.droppableProps, { ref: provided.innerRef }), collections === null || collections === void 0 ? void 0 :
            collections.map(function (collection, index) { return (React.createElement(Collection, { key: collection.id, selectedChannelId: value, index: index, expanded: expandedCollectionsSet.has(collection.id), showActions: showActions, showDivider: index < collections.length - 1, collection: collection, onClick: onClick, onClickChannel: onClickChannel, onEdit: onEdit, onAddChannel: onAddChannel })); }),
            provided.placeholder)); })));
};

export { Collections as default };
//# sourceMappingURL=Collections.js.map
